<template lang="pug">
  div
    section.content-header
      h1 データの保存期間設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active データの保存期間設定

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル

        +btnbar
        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-body
            .form-group
              label.control-label 画像からの登録状況履歴
              .row
                .col-xs-3
                  select.form-control(v-model="saveImageEntry")
                    option(v-for="i in optionNum" :value="i" :key="i") {{i}} ヶ月
                    option(value="0") 無制限
              .help-block
                p.bcard-comments.text-info
                  | ※ アップロード日時からの経過日数で削除します。
                p.bcard-comments.text-danger
                  | ※ 画像の解析、修正サービスが終了している履歴を削除します。（画像解析中、修正サービス依頼中のデータは削除しません。）
            hr

            .form-group
              label.control-label インポート履歴
              .row
                .col-xs-3
                  select.form-control(v-model="saveImportLog")
                    option(v-for="i in optionNum" :value="i" :key="i") {{i}} ヶ月
                    option(value="0") 無制限
              .help-block
                p.bcard-comments.text-info
                  | ※ CSVから一括登録、個人データのインポートの履歴を削除します。
                  br
                  | インポート日時からの経過日数で削除します。
                p.bcard-comments.text-danger
                  | ※ インポート処理が終了している履歴を削除します。（インポート待ち、インポート中のデータは削除しません。）
            hr

            .form-group
              label.control-label 操作ログ
              .row
                .col-xs-3
                  select.form-control(v-model="saveAccessLog")
                    option(v-for="i in optionNum" :value="i" :key="i") {{i}} ヶ月
                    option(value="0") 無制限
              .help-block
                p.bcard-comments.text-info
                  | ※ 操作日からの経過日数で削除します。

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExpireSettingRepository = RepositoryFactory.get('expiresettings')

export default {
  name: 'ExpireSetting',
  components: { AppMessages, Loading },
  data: function () {
    return {
      saveImageEntry: 0, // 画像からの登録状況履歴
      saveImportLog: 0, // インポート履歴
      saveAccessLog: 0, // 操作ログ
      optionNum: 36, // 項目数

      isLoading: true // 読み込み中かどうか
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    const vm = this

    // API実行
    ExpireSettingRepository.get()
      .then(function (response) {
        const res = vm.getApiData(response).data
        // 画像からの登録状況履歴
        vm.saveImageEntry = res.save_image_entry
        // インポート履歴
        vm.saveImportLog = res.save_import_log
        // 操作ログ
        vm.saveAccessLog = res.save_access_log
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  // データの保存期間設定共通メソッド
  methods: {
    // 送信処理
    postData: function () {
      const vm = this
      const sendData = {}

      sendData['save_image_entry'] = this.saveImageEntry // 画像からの登録状況履歴
      sendData['save_import_log'] = this.saveImportLog // インポート履歴
      sendData['save_access_log'] = this.saveAccessLog // 操作ログ

      // API実行
      ExpireSettingRepository.put(sendData)
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/ExpireSetting.vue